<template>
  <FullPage>
    <div class="login-logo">
      <el-image :src="require('@/assets/images/logo.png')" />
    </div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <el-form
        ref="form"
        label-position="top"
        :model="loginForm"
        class="login-form"
      >
        <FormItem
          rules="required"
          :label="$t('auth.login.username')"
        >
          <el-input v-model="loginForm.username" />
        </FormItem>
        <FormItem
          rules="required"
          :label="$t('auth.login.password')"
        >
          <el-input
            v-model="loginForm.password"
            show-password
          />
        </FormItem>

        <el-row
          type="flex"
          justify="end"
        >
          <el-col :span="8">
            <FormItem margin-bottom-size="none">
              <el-button
                type="primary"
                native-type="submit"
                class="full-width"
                :disabled="isLoggingIn"
                @click.prevent="handleSubmit(loginUser)"
              >
                {{ $t('auth.login.loginButton') }}
              </el-button>
            </FormItem>
          </el-col>
        </el-row>
      </el-form>
    </ValidationObserver>
  </FullPage>
</template>

<script>
  import { mapActions } from 'vuex';

  import { usersApi } from '@/api';
  import FormItem from '@/components/FormItem.vue';
  import FullPage from '@/components/FullPage.vue';

  const isProduction = process.env.NODE_ENV === 'production';

  export default {
    name: 'Login',
    components: {
      FormItem,
      FullPage,
    },
    data() {
      return {
        loginForm: {
          username: isProduction ? '' : 'Sicuser1',
          password: isProduction ? '' : 'S123!!!',
        },
        isLoggingIn: false,
      };
    },
    methods: {
      ...mapActions(['resetStore']),
      async loginUser() {
        if (this.isLoggingIn) return;

        this.isLoggingIn = true;
        const loading = this.$loading({
          lock: true,
          background: 'rgba(48,53,82,0.9)',
        });

        try {
          await usersApi.login(this.loginForm);
          // Resets store status
          this.resetStore();
          await this.$router.push({ name: 'postLogin' });
        } catch (error) {
          this.$notify({
            type: 'error',
            message: error.response.data.error.message,
          });
        } finally {
          loading.close();
          this.isLoggingIn = false;
        }
      },
    },
  };
</script>

<style lang="scss">
  .login-logo {
    text-align: center;
    margin-bottom: 50px;

    img {
      background-color: hsl(224 11% 90% / 1);
      border-radius: 4px;
      width: 80%;
    }
  }
</style>
